module.exports = __webpack_public_path__ + "img/ZJ5149.2c474c50.png";